// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { message16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-message': IconMessage;
    }
}

/**
 * The icon component for the 'message' icon
 */
export class IconMessage extends IconSvg {
    public constructor() {
        super(message16X16);
    }
}

registerIconSvg('icon-message', IconMessage);
export const iconMessageTag = 'nimble-icon-message';
